module.exports = __webpack_public_path__ + "fontawesome-webfont.svg";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.svg?v=4.7.0
// module id = 1235
// module chunks = 11